const r = ':host{display:block}.sl-footer{display:flex;align-items:center;justify-content:space-between;padding:var(--sl-footer-padding,1.5rem 1rem);background:hsl(var(--sl-hsl-background));color:hsl(var(--sl-hsl-foreground));border-top:1px solid hsl(var(--sl-hsl-border));gap:1rem;flex-wrap:wrap}.sl-footer--minimal{padding:var(--sl-footer-padding,1rem);border-top:1px solid hsl(var(--sl-hsl-border) / 0.5)}.sl-footer__start{display:flex;align-items:center;flex:1;gap:0.5rem}.sl-footer__center{display:flex;align-items:center;justify-content:center;flex:1;gap:1rem}.sl-footer__end{display:flex;align-items:center;justify-content:flex-end;flex:1;gap:0.5rem}.sl-footer__start slot[name="start"]::slotted(*),.sl-footer__center slot[name="center"]::slotted(*),.sl-footer__end slot[name="end"]::slotted(*){display:flex;align-items:center}@media (max-width:768px){.sl-footer{flex-direction:column;text-align:center;gap:0.75rem}.sl-footer__start,.sl-footer__center,.sl-footer__end{justify-content:center}}';
class l extends HTMLElement {
  static get observedAttributes() {
    return ["variant"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    this._render();
  }
  disconnectedCallback() {
  }
  attributeChangedCallback(e, t, s) {
    t !== s && this._render();
  }
  get variant() {
    return this.getAttribute("variant") || "default";
  }
  set variant(e) {
    this.setAttribute("variant", e);
  }
  _getClasses() {
    const e = ["sl-footer"];
    return e.push(`sl-footer--${this.variant}`), e.join(" ");
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${r}</style>
      <div class="${this._getClasses()}">
        <div class="sl-footer__start">
          <slot name="start"></slot>
        </div>
        <div class="sl-footer__center">
          <slot name="center"></slot>
        </div>
        <div class="sl-footer__end">
          <slot name="end"></slot>
        </div>
      </div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-footer") && customElements.define("sl-footer", l);
export {
  l as SlFooterElement
};
//# sourceMappingURL=sl-footer.js.map
